import script from "./RouteTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteTransition.vue?vue&type=script&setup=true&lang=js"

import "./RouteTransition.vue?vue&type=style&index=0&id=216a8934&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216a8934"]])

export default __exports__